import React, { useEffect } from "react";
import { LeftSearchMenuPiece } from "../search/LeftSearchMenuPiece";
import { Checkbox } from "@deere/ux.uxframe-react";
import { useDispatch } from "react-redux";
import { setUnitSelection } from "../redux/action/filterAction";

export const UnitTypeFilter = ({ setUnitSelected, units = [], unitSelected = [], setShowDeereFilter, setShowNonDeereFilter }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const array = [];
    if (units) {
      units.forEach((s) => {
        if (s.checked) array.push(s.id);
      });
      setUnitSelected(array);
    }
  }, [setUnitSelected, units]);

  const handleUnitTypeCheckBoxChange = (event) => {
    const code = event.target.id;
    if (!unitSelected.includes(code)) {
      unitSelected.push(code);
      code === "DU" ? setShowDeereFilter(true) : setShowNonDeereFilter(true);
    } else {
      const index = unitSelected.indexOf(code);
      if (index > -1) {
        unitSelected.splice(index, 1);
        code === "DU" ? setShowDeereFilter(false) : setShowNonDeereFilter(false);
      }
    }
    setUnitSelected([...unitSelected]);
    updateUnits(code);
  };

  const updateUnits = (code) => {
    const updatedIndex = units.findIndex((ns) => ns.id === code);
    units[updatedIndex].checked = !units[updatedIndex].checked;
    dispatch(setUnitSelection(units));
  };

  return (
    <LeftSearchMenuPiece>
      <LeftSearchMenuPiece.Item id="unit_type_filter" title="Unit Type">
        {units.map((s) => (
          <Checkbox key={s.id} label={s.label} id={s.id} onChange={handleUnitTypeCheckBoxChange} checked={s.checked} />
        ))}
      </LeftSearchMenuPiece.Item>
    </LeftSearchMenuPiece>
  );
};
